$(function () {
    'use strict';


    /**
     *  Amazonの商品情報を表示
     **/
    var connecting = false;


    /**
     * Amazonの商品を表示
     **/
    function showAmazonItems(nodes, callback) {

        if (!callback) {
            callback = function () { };
        }

        //同時接続しないようにする処理
        if (connecting) {
            setTimeout(function () {
                showAmazonItems(nodes, callback);
            }, 500);
            return;
        }

        connecting = true;
        var req_items = {};
        var nonce;

        nodes.each(function (node) {
            var req_id = $(this).data('req-id');
            var asin = $(this).data('asin');
            var title = $(this).data('title');
            var list_price = $(this).data('list-price');
            var sale_price = $(this).data('sale-price');
            var display_price = $(this).data('display-price');
            var mode = $(this).data('mode');
            var style = $(this).data('style');
            var image_width = $(this).data('image_width');
            var image_height = $(this).data('image_height');
            var sale = $(this).data('sale');
            var cache = $(this).data('cache');
            var nonce = $(this).data('nonce');
            var version = $(this).data('version');
            var show_lowest_price = $(this).data('show_lowest_price');
            var show_keepa = $(this).data('show_keepa');
            var hide_price = $(this).data('hide_price');
            var hide_attributes = $(this).data('hide_attributes');
            var is_new_template_v2 = $(this).data('is-new-template-v2');
            req_items[req_id] = {
                'asin': asin,
                'title': title,
                'mode': mode,
                'style': style,
                'image_width': image_width,
                'image_height': image_height,
                'sale': sale,
                'list_price': list_price,
                'sale_price': sale_price,
                'display_price': display_price,
                'cache': cache,
                'nonce': nonce,
                'version': version,
                'show_lowest_price': show_lowest_price,
                'show_keepa': show_keepa,
                'is_new_template_v2': is_new_template_v2,
                'hide_price': hide_price,
                'hide_attributes': hide_attributes,
            };
        });
        console.log('req_items', req_items);

        $.ajax({
            url: moko.ajaxurl,
            type: 'POST',
            dataType: 'json',
            timeout: 30000,
            cache: false,
            data: {
                'action': 'moko_amazon_item',
                'req_items': JSON.stringify(req_items),
            }
        }).
            fail(function (xhr, status, error) {
                showMessage(nodes, '通信エラーが発生しました');
                var error_message = "amazon_item:" + error + ":" + status + ":" + xhr.status;
                console.error(error_message);
                ga("all.send", "exception", { "exDescription": error_message });
            }).
            done(function (data) {

                if (data.data && data.data.error) {
                    showMessage(nodes, data.data.error);
                } else {
                    for (var req_id in data) {
                        showAmazonItem(req_id, data[req_id]);
                    }
                    // Ajaxで追加された商品HTML内の運営UI placeholderを取得する。
                    // 初期DOMContentLoaded時点ではplaceholderが存在しないため、
                    // ここで再走査しないとamazon_itemの管理UIが表示されない。
                    if (window.moko && typeof moko.loadOperationsFragments === 'function') {
                        moko.loadOperationsFragments(document);
                    }
                }
            }).always(function () {
                connecting = false;
                callback();
            });
    }


    function showAmazonList(node, callback) {

        if (!callback) {
            callback = function () { };
        }

        var filters = $(node).data('filters');
        //console.log(filters);
        var ttl = $(node).data('ttl');
        var nonce = $(node).data('nonce');
        var version = $(node).data('version');
        var is_new_template_v2 = $(node).data('is-new-template-v2');
        var req = {
            'filters': filters,
            'ttl': ttl,
            'nonce': nonce,
            'version': version,
            'is_new_template_v2': is_new_template_v2,
        };
        //console.log('req',req);

        $.ajax({
            url: moko.ajaxurl,
            type: 'POST',
            dataType: 'json',
            timeout: 30000,
            cache: false,
            data: {
                'action': 'moko_amazon_list',
                'request': JSON.stringify(req),
            }
        }).
            fail(function (xhr, status, error) {
                showMessage($(node), '通信エラーが発生しました');
                var error_message = "amazon_item:" + error + ":" + status + ":" + xhr.status;
                console.error(error_message);
                ga("all.send", "exception", { "exDescription": error_message });
            }).
            done(function (data) {
                //console.log(data)
                $(node).html(data);
                if (window.moko && typeof moko.loadOperationsFragments === 'function') {
                    moko.loadOperationsFragments(node);
                }
            }).always(function () {
                callback();
            });
    }


    function showAmazonItem(req_id, html) {
        $('.amazon-item-' + req_id).html(html);
    }

    function showMessage(node, message) {
        node.find('.amazon-item-error').html(message);
    }


    /**
     *  Amazonの商品情報を取得する
     **/
    moko.initAmazonItems = function (content) {

        var nodes = [];

        var onece_num = 10;
        var all_nodes = content.find('.ajax-amazon-item');
        var slice_num = Math.ceil(all_nodes.length / onece_num);
        for (var i = 0; i < slice_num; i++) {
            nodes = all_nodes.slice(i * onece_num, (i * onece_num) + onece_num);
            showAmazonItems(nodes);
        }

        content.find('.ajax-amazon-list').each(function (node) {
            showAmazonList(this);
        });
    };



    moko.initAmazonItems($(document));

    // フラグメント挿入後も機能するよう、キャッシュ削除はdocumentへ委譲する。
    $(document).on('click', '.amazon-item-cache-clear-button', function (event) {
        event.preventDefault();
        var button = $(this);
        var root = button.closest('.amazon-item-cache-clear-operations, .amazon-item-cache-clear-admin');
        var message = root.find('.amazon-item-cache-clear-message');
        var asin = root.attr('data-asin') || '';
        var version = parseInt(root.attr('data-version') || '3', 10);
        var nonce = root.attr('data-nonce') || '';
        if (!window.moko || !moko.ajaxurl || !asin || !nonce) {
            message.text('キャッシュ削除の準備に失敗しました');
            return;
        }
        button.addClass('disabled').css('pointer-events', 'none');
        message.text('削除中...');
        $.ajax({
            url: moko.ajaxurl,
            type: 'POST',
            dataType: 'json',
            timeout: 30000,
            cache: false,
            data: {
                action: 'moko_amazon_item_clear_cache',
                request: JSON.stringify({ asin: asin, version: version, nonce: nonce })
            }
        }).done(function (response) {
            if (response && response.success) {
                message.text('削除しました。再読み込みします...');
                setTimeout(function () { window.location.reload(); }, 300);
                return;
            }
            message.text(response && response.data && response.data.message ? response.data.message : '削除に失敗しました');
            button.removeClass('disabled').css('pointer-events', '');
        }).fail(function () {
            message.text('通信エラーが発生しました');
            button.removeClass('disabled').css('pointer-events', '');
        });
    });

});
